import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalShell from "../modal/ModalShell";

interface NoteModalProps {
  title: string;
  description?: string;
  confirmLabel: string;
  /** When true an empty note blocks confirm (e.g. voiding requires a reason). */
  noteRequired?: boolean;
  onConfirm: (note: string) => void;
  onCancel: () => void;
}

/** Small prompt used by money actions that carry a note (void payment, cancel contract). */
const NoteModal: React.FC<NoteModalProps> = ({
  title,
  description,
  confirmLabel,
  noteRequired = false,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [note, setNote] = useState("");
  const blocked = noteRequired && note.trim().length === 0;

  return (
    <ModalShell
      onClose={onCancel}
      labelledBy="note-modal-title"
      describedBy={description ? "note-modal-description" : undefined}
    >
      <div className="p-6">
        <h3 id="note-modal-title">{title}</h3>
        {description && (
          <p id="note-modal-description" className="mt-2 text-sm text-grey-30 dark:text-grey-70">
            {description}
          </p>
        )}
        <textarea
          className="input mt-4 min-h-[90px]"
          placeholder={noteRequired ? t("billing.noteModal.reasonRequired") : t("billing.noteModal.noteOptional")}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <div className="mt-4 flex justify-end gap-3">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            {t("billing.common.cancel")}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={blocked}
            onClick={() => onConfirm(note.trim())}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </ModalShell>
  );
};

export default NoteModal;
